module.exports = "https://static.zego.com/_next/static/images/Annual-17d2619d416646e53a63805453c2834d.svg";